(function () {
  'use strict';
  function CS(k, fr) { return (window.CatedoStrings && window.CatedoStrings[k]) || fr; }

  /* 15.10 : préfixe de langue (/de/, /en/) pour charger les produits et le panier dans la langue de la page */
  var ROOT          = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var COLLECTION    = ROOT + 'collections/accessoires-pour-chat';
  var PRODUCTS_URL  = COLLECTION + '/products.json?limit=12';
  var CADEAUX_URL   = ROOT + 'collections/cadeaux-catedo/products.json?limit=20';
  var cadeauxIds    = null; // ids des produits offerts, chargés une seule fois
  var reinitTimer   = null;
  var isBuilding    = false;
  var lastCartHash  = null; // signature du panier au dernier build — evite les rebuilds inutiles

  /* Debounced re-init — Catedo 27.08.2026 : attend la fin des requêtes
     panier en vol (window.CatedoCartFluid.busy) pour ne jamais reconstruire
     pendant l'opération principale, puis passe par requestIdleCallback
     (avec repli direct) pour rester hors du chemin critique du rendu.
     clearTimeout garantit qu'une reconstruction devenue obsolète est
     annulée au profit de la plus récente. */
  function scheduleReinit(delay) {
    clearTimeout(reinitTimer);
    reinitTimer = setTimeout(function () {
      if (window.CatedoCartFluid && window.CatedoCartFluid.busy > 0) {
        scheduleReinit(400);
        return;
      }
      if (typeof window.requestIdleCallback === 'function') {
        /* Onglet masqué : Chrome peut ne jamais servir les périodes
           d'inactivité. Minuterie de secours (garde d'exécution unique)
           pour que la reconstruction parte au plus tard après 2 s. */
        var ran = false;
        var runOnce = function () { if (ran) return; ran = true; init(); };
        var ricId = window.requestIdleCallback(runOnce, { timeout: 1500 });
        setTimeout(function () {
          if (!ran && typeof window.cancelIdleCallback === 'function') window.cancelIdleCallback(ricId);
          runOnce();
        }, 2000);
      } else {
        init();
      }
    }, delay || 400);
  }

  /* Cache de la liste produits (statique) : évite de re-télécharger
     products.json à chaque reconstruction. TTL 5 minutes. */
  var productsCache = null;
  var productsCacheAt = 0;
  function getProducts() {
    if (productsCache && (Date.now() - productsCacheAt) < 300000) {
      return Promise.resolve(productsCache);
    }
    return fetch(PRODUCTS_URL)
      .then(function (r) { return r.json(); })
      .then(function (data) {
        productsCache = data.products || [];
        productsCacheAt = Date.now();
        return productsCache;
      });
  }

  /* Main init */
  function init() {
    if (isBuilding) return;

    var carousel = document.getElementById('cartAccCarousel');
    if (!carousel) return;

    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cartData) {
        /* Le carrousel se masquait dès 50 € — le seuil de la livraison offerte.
           Il laissait alors un grand vide sous les articles, et surtout il
           disparaissait juste au moment où le client n'a plus qu'un article à
           ajouter pour décrocher le cadeau. Il reste maintenant affiché tant
           qu'il a quelque chose à proposer. */
        var cartPids = cartData.items.map(function (i) { return i.product_id; });
        /* Hash du panier : si identique au precedent, pas besoin de rebuild */
        var cartHash = cartPids.sort().join(',') + ':' + cartData.total_price;
        if (cartHash === lastCartHash) return;

        /* Les cadeaux sont dans la collection accessoires : les proposer à
           l'achat juste au-dessus de « Offert » n'aurait aucun sens. */
        var cadeaux = cadeauxIds
          ? Promise.resolve(cadeauxIds)
          : fetch(CADEAUX_URL)
              .then(function (r) { return r.json(); })
              .then(function (d) {
                cadeauxIds = d.products.map(function (p) { return p.id; });
                return cadeauxIds;
              })
              .catch(function () { cadeauxIds = []; return cadeauxIds; });

        return Promise.all([getProducts(), cadeaux])
          .then(function (res) {
            var products = res[0], exclus = res[1] || [];
            var filtered = products.filter(function (p) {
              return cartPids.indexOf(p.id) === -1 && exclus.indexOf(p.id) === -1;
            });
            if (filtered.length === 0) {
              carousel.style.display = 'none';
              lastCartHash = cartHash;
              return;
            }
            lastCartHash = cartHash;
            buildCarousel(carousel, filtered);
          });
      })
      .catch(function () {});
  }

  /* Build carousel */
  function buildCarousel(carousel, products) {
    isBuilding = true;

    var prevBtn  = carousel.querySelector('.cart-acc-carousel__nav--prev');
    var nextBtn  = carousel.querySelector('.cart-acc-carousel__nav--next');
    var viewport = carousel.querySelector('.cart-acc-carousel__viewport');
    var track    = carousel.querySelector('.cart-acc-carousel__track');
    if (!prevBtn || !nextBtn || !viewport || !track) { isBuilding = false; return; }

    var pageIdx = 0;

    function isMobile()      { return window.innerWidth <= 749; }
    function cardsPerPage()  { return isMobile() ? 1 : 2; }
    function getGap()        { var g = parseFloat(getComputedStyle(track).columnGap); return isNaN(g) ? 16 : g; }
    function getSlideWidth() { return viewport.clientWidth + getGap(); }
    function totalPages()    { return Math.max(1, Math.ceil(track.children.length / cardsPerPage())); }

    function updateNav() {
      prevBtn.classList.toggle('is-disabled', pageIdx <= 0);
      prevBtn.setAttribute('aria-disabled', pageIdx <= 0 ? 'true' : 'false');
      var atEnd = pageIdx >= totalPages() - 1;
      nextBtn.classList.toggle('is-disabled', atEnd);
      nextBtn.setAttribute('aria-disabled', atEnd ? 'true' : 'false');
    }

    function goTo(n) {
      pageIdx = Math.max(0, Math.min(n, totalPages() - 1));
      track.style.transform = 'translateX(-' + (pageIdx * getSlideWidth()) + 'px)';
      updateNav();
    }

    function setCardWidths() {
      var w = cardsPerPage() === 1
        ? viewport.clientWidth + 'px'
        : Math.floor((viewport.clientWidth - getGap()) / 2) + 'px';
      Array.from(track.children).forEach(function (c) { c.style.width = w; });
    }

    /* Build product cards
       /products.json retourne les prix en decimal string ex: "37.90" (pas en cents) */
    track.innerHTML = '';
    products.forEach(function (p) {
      var rawSrc = p.images && p.images.length ? p.images[0].src : '';
      var imgSrc = rawSrc ? rawSrc.replace(/\.(jpe?g|png|gif|webp)/i, '_300x.$1') : '';
      var amount = p.variants && p.variants[0] ? parseFloat(p.variants[0].price) : 0;
      var price  = amount.toFixed(2).replace('.', ',') + '€';
      var vid    = p.variants && p.variants[0] ? p.variants[0].id : 0;
      var title  = p.title;

      var card = document.createElement('div');
      card.className = 'cart-acc-carousel__card';
      card.innerHTML =
        '<a href="' + ROOT + 'products/' + p.handle + '" class="cart-acc-carousel__img-link" tabindex="-1" aria-hidden="true">' +
          /* width et height declares : sans eux le navigateur ne connait pas la place
       a reserver et la carte saute quand l'image arrive. Les valeurs sont celles
       du carre affiche, 88 x 88, le rapport est donc exact. */
    (imgSrc ? '<img class="cart-acc-carousel__img" src="' + imgSrc + '" alt="" width="88" height="88" loading="lazy" decoding="async">' : '') +
          '<span class="cart-acc-carousel__badge">' + price + '</span>' +
        '</a>' +
        '<div class="cart-acc-carousel__right">' +
          '<div class="cart-acc-carousel__info">' +
            '<p class="cart-acc-carousel__name">' + title + '</p>' +
          '</div>' +
          '<button class="cart-acc-carousel__atc" data-variant-id="' + vid + '">' + CS('addToCart', 'Ajouter au panier') + '</button>' +
        '</div>';
      track.appendChild(card);
    });

    /* Carte CTA en fin de carousel */
    var cta = document.createElement('div');
    cta.className = 'cart-acc-carousel__card cart-acc-carousel__card--cta';
    cta.innerHTML =
      '<svg class="cart-acc-carousel__cta-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/></svg>' +
      '<p class="cart-acc-carousel__cta-text">' + CS('seeAll', 'Voir tous les produits') + '</p>' +
      '<a href="' + CS('allUrl', '/collections/all') + '" class="cart-acc-carousel__cta-btn">' + CS('browse', 'Parcourir') + '</a>';
    track.appendChild(cta);

    carousel.style.display = '';
    requestAnimationFrame(function () {
      requestAnimationFrame(function () { setCardWidths(); goTo(0); isBuilding = false; });
    });

    /* Nav (desktop) */
    prevBtn.onclick = function () { if (!prevBtn.classList.contains('is-disabled')) goTo(pageIdx - 1); };
    nextBtn.onclick = function () { if (!nextBtn.classList.contains('is-disabled')) goTo(pageIdx + 1); };

    /* Swipe tactile (mobile) */
    var touchStartX = 0;
    viewport.addEventListener('touchstart', function (e) {
      touchStartX = e.changedTouches[0].clientX;
    }, { passive: true });
    viewport.addEventListener('touchend', function (e) {
      var diff = touchStartX - e.changedTouches[0].clientX;
      if (Math.abs(diff) > 40) {
        if (diff > 0) goTo(pageIdx + 1);
        else goTo(pageIdx - 1);
      }
    }, { passive: true });

    /* ATC */
    track.addEventListener('click', function (e) {
      var btn = e.target.closest('.cart-acc-carousel__atc');
      if (!btn || btn.disabled) return;
      var vid = parseInt(btn.dataset.variantId, 10);
      if (!vid) return;

      btn.disabled = true;
      btn.textContent = '...';

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: vid, quantity: 1 }] })
      })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (data.status) { btn.disabled = false; btn.textContent = CS('addToCart', 'Ajouter au panier'); return; } // erreur API

        btn.textContent = CS('added', '✓ Ajouté');

        /* Fade out la carte */
        var card = btn.closest('.cart-acc-carousel__card');
        if (card) {
          card.style.transition = 'opacity .25s';
          card.style.opacity = '0';
          setTimeout(function () { card.remove(); }, 270);
        }

        /* Rafraichit le drawer puis re-init le carousel */
        refreshCartDrawer(function () { scheduleReinit(600); });
      })
      .catch(function () { btn.disabled = false; btn.textContent = CS('addToCart', 'Ajouter au panier'); });
    });
  }

  /* Rafraichit le drawer apres ATC */
  function refreshCartDrawer(callback) {
    fetch(ROOT + '?sections=cart-drawer')
      .then(function (r) { return r.json(); })
      .then(function (sections) {
        var html = sections['cart-drawer'];
        if (!html) { fallbackRefresh(); if (callback) callback(); return; }

        var parser = new DOMParser();
        var doc    = parser.parseFromString(html, 'text/html');

        /* Liste articles panier */
        var srcItems = doc.getElementById('CartDrawer-CartItems');
        var dstItems = document.getElementById('CartDrawer-CartItems');
        if (srcItems && dstItems) dstItems.innerHTML = srcItems.innerHTML;

        /* Footer totaux (.cart-drawer__footer = totaux seulement, PAS le carousel) */
        var srcFoot = doc.querySelector('.cart-drawer__footer');
        var dstFoot = document.querySelector('.cart-drawer__footer');
        if (srcFoot && dstFoot) dstFoot.innerHTML = srcFoot.innerHTML;

        /* Bulle compteur */
        var srcBubble = doc.querySelector('.cart-count-bubble');
        var dstBubble = document.querySelector('.cart-count-bubble');
        if (srcBubble && dstBubble) dstBubble.innerHTML = srcBubble.innerHTML;

        /* Barre de progression */
        var srcProg = doc.querySelector('.cart-progress');
        var dstProg = document.querySelector('.cart-progress');
        if (srcProg && dstProg) dstProg.innerHTML = srcProg.innerHTML;

        if (callback) callback();
      })
      .catch(function () { fallbackRefresh(); if (callback) callback(); });
  }

  /* Fallback: mise a jour manuelle via /cart.js */
  function fallbackRefresh() {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (c) {
        document.querySelectorAll('.cart-count-bubble').forEach(function (el) {
          var s = el.querySelector('[aria-hidden]');
          if (s) s.textContent = c.item_count;
          el.style.display = '';
        });
        var sv = document.querySelector('.totals__subtotal-value');
        if (sv) sv.textContent = (c.total_price / 100).toFixed(2).replace('.', ',') + '€';
        var sl = document.querySelector('.totals__subtotal');
        if (sl) sl.textContent = 'Sous-total (' + c.item_count + ' ' + (c.item_count > 1 ? 'articles' : 'article') + ')';
        var pb = document.querySelector('.cart-progress__bar__progress');
        if (pb) pb.style.width = Math.min(100, Math.round(c.total_price / 5000 * 100)) + '%';
        var pt = document.querySelector('.cart-progress__text');
        if (pt) {
          if (c.total_price < 5000) {
            var rem = ((5000 - c.total_price) / 100).toFixed(2).replace('.', CS('decimal', ','));
            pt.textContent = CS('shipMore', 'Plus que [amount]€ pour bénéficier de la livraison offerte').replace('[amount]', rem);
          } else {
            pt.textContent = CS('shipUnlocked', 'Livraison offerte débloquée !');
          }
        }
      });
  }

  /* Observer .drawer__inner — c'est LUI que Dawn remplace entierement quand
     un article est supprime (CartDrawerItems.getSectionsToRender renvoie
     selector: '.drawer__inner'). Surveiller #CartDrawer-CartItems ne suffit
     pas car Dawn detruit et recrée l'element, l'observer devient orphelin.

     IMPORTANT : on ignore les mutations qui viennent de #cartAccCarousel car
     buildCarousel() modifie le DOM dedans et sans ce filtre on declenche une
     boucle infinie de reinit toutes les 500ms (=> clignotement visuel). */
  function watchDrawerInner() {
    var drawerInner = document.querySelector('.drawer__inner');
    if (!drawerInner) return;

    /* subtree:true — capture les mutations à toute profondeur dans .drawer__inner */
    new MutationObserver(function (mutations) {
      /* Filtre : si TOUTES les mutations viennent de notre propre carousel,
         on ignore (sinon boucle). On ne reagit qu'aux changements du panier. */
      var carousel = document.getElementById('cartAccCarousel');
      var external = mutations.some(function (m) {
        return !carousel || !carousel.contains(m.target);
      });
      if (external) scheduleReinit(500);
    }).observe(drawerInner, { childList: true, subtree: true });

    /* Observer le parent : si Dawn remplace .drawer__inner lui-même, le
       parent détecte le changement et on relance watchDrawerInner */
    var parent = drawerInner.parentNode;
    if (parent) {
      new MutationObserver(function () {
        scheduleReinit(500);
        watchDrawerInner();
      }).observe(parent, { childList: true });
    }
  }

  /* Catedo 27.08.2026 — pré-révélation sans requête : après un échange de
     sections, le nouveau #cartAccCarousel arrive masqué (display:none en
     dur) et le bouton « Ajouter un article » disparaissait ~1 s avant que
     init() le ré-affiche (saut visuel). La barre de progression rendue par
     le serveur dans le même HTML donne la vérité : width:100% ⇔ seuil
     livraison offerte atteint. On applique immédiatement le bon état ;
     init() reste l'autorité et corrige ensuite si besoin. */
  function preReveal() {
    var carousel = document.getElementById('cartAccCarousel');
    if (!carousel) return;
    var bar = document.querySelector('.cart-progress__bar__progress');
    if (!bar || !bar.style.width) return; /* barre absente : init decidera */
    var w = parseFloat(bar.style.width);
    if (isNaN(w)) return;
    carousel.style.display = w < 100 ? '' : 'none';
  }

  /* Watcher : detecte quand Dawn re-rend le drawer (suppression/modification d'article)
     pour relancer init() qui re-affichera le carousel/bouton si le panier passe sous 50€.
     Filtre : ignore les mutations INTERNES au carousel pour eviter la boucle de clignotement.
     Le hash du panier (cf init) garantit qu'on ne rebuild que si quelque chose a vraiment change. */
  var innerObserver = null;
  var parentObserver = null;
  function watchDrawerInner() {
    if (innerObserver) innerObserver.disconnect();
    if (parentObserver) parentObserver.disconnect();

    var drawerInner = document.querySelector('.drawer__inner');
    if (!drawerInner) return;

    innerObserver = new MutationObserver(function (mutations) {
      var carousel = document.getElementById('cartAccCarousel');
      var external = mutations.some(function (m) {
        return !carousel || !carousel.contains(m.target);
      });
      if (external) { preReveal(); scheduleReinit(600); }
    });
    innerObserver.observe(drawerInner, { childList: true, subtree: true });

    var parent = drawerInner.parentNode;
    if (parent) {
      parentObserver = new MutationObserver(function () {
        preReveal();
        scheduleReinit(600);
        watchDrawerInner();
      });
      parentObserver.observe(parent, { childList: true });
    }
  }

  /* Boot */
  document.addEventListener('DOMContentLoaded', function () {
    init();
    watchDrawerInner();
  });

  /* Fix Safari bfcache : nettoyage uniquement au restore depuis le cache
     navigateur (back/forward). Pas au premier chargement pour eviter
     d'interferer avec le rendu initial. */
  window.addEventListener('pageshow', function (e) {
    if (!e.persisted) return;
    document.body.classList.remove('overflow-hidden');
    var cartDrawer = document.querySelector('cart-drawer');
    if (cartDrawer) cartDrawer.classList.remove('active', 'animate');
  });
})();
